export const config = window.REACT_APP_CONFIG
